import { useGetIdentity, useTranslate } from "ra-core";
import { CreateSheet } from "../misc/CreateSheet";
import { ContractInputs } from "./ContractInputs";

interface ContractCreateSheetProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const ContractCreateSheet = ({ open, onOpenChange }: ContractCreateSheetProps) => {
  const { identity } = useGetIdentity();
  const translate = useTranslate();
  return (
    <CreateSheet
      resource="contracts"
      title={translate("resources.contracts.action.new", { _: "Новый договор" })}
      defaultValues={{
        sales_id: identity?.id,
        status: "active",
        payment_type: "one_time",
        total_amount: 0,
        start_date: new Date().toISOString().slice(0, 10),
        payment_schedule: {},
      }}
      open={open}
      onOpenChange={onOpenChange}
    >
      <ContractInputs />
    </CreateSheet>
  );
};
